import { Controller } from "@hotwired/stimulus"

// Keeps a destructive submit button disabled until the expected text - usually the name of the thing
// being deleted - has been typed exactly. Both sides are trimmed, so stray whitespace in a stored
// name can't make it impossible to match. The server checks the same text again; this only saves a
// round trip.
//
//   data-controller="typed-confirmation"
//   data-typed-confirmation-expected-value="Acme Group"
//   input:  data-typed-confirmation-target="input" data-action="input->typed-confirmation#check"
//   button: data-typed-confirmation-target="submit"
export default class extends Controller {
  static targets = ["input", "submit"]
  static values = { expected: String }

  connect() {
    this.check()
  }

  check() {
    this.submitTarget.disabled = this.inputTarget.value.trim() !== this.expectedValue.trim()
  }
}
